import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

const VideoModal = ({ videoId, isOpen, onClose }) => {
  const youtubeUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <button onClick={onClose}>x</button>
      <iframe
        width="853"
        height="480"
        src={youtubeUrl}
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </Modal>
  );
};

export default VideoModal;
